import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M51.41 51.45C51.41 51.45 52.5001 34.83 52.0701 27.23C52.0701 27.23 53.6 26.0199 52.73 23.9299C52.73 23.9299 55.14 21.07 52.73 18.54C52.73 18.54 53.93 16.23 53.17 14.03C52.41 11.83 50.8701 11.83 50.8701 11.83C50.8701 11.83 51.0901 9.07996 48.2501 9.07996C48.2501 9.07996 48.9101 4.89997 43.8801 5.33997C43.8801 5.33997 43.7701 3.24993 40.4901 3.79993C40.4901 3.79993 37.7601 0.719985 34.7001 3.35999C34.7001 3.35999 32.95 1.82001 30.98 3.14001C30.98 3.14001 29.3401 1.48999 27.3701 1.48999C25.4001 1.48999 24.5301 3.14001 24.5301 3.14001C22.5601 1.82001 20.8101 3.35999 20.8101 3.35999C17.7501 0.719985 15.0201 3.79993 15.0201 3.79993C11.7401 3.24993 11.6301 5.33997 11.6301 5.33997C6.60007 4.89997 7.26008 9.07996 7.26008 9.07996C4.42008 9.07996 4.64008 11.83 4.64008 11.83C4.64008 11.83 3.11009 11.83 2.34009 14.03C1.57009 16.23 2.7801 18.54 2.7801 18.54C0.370095 21.07 2.7801 23.9299 2.7801 23.9299C1.9101 26.0199 3.44007 27.23 3.44007 27.23C3.00007 34.83 4.10004 51.45 4.10004 51.45L6.94007 25.36C6.94007 25.36 9.67009 21.51 27.7101 21.51C45.7501 21.51 48.5901 25.36 48.5901 25.36L51.41 51.45Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
  )
}
